import { render, staticRenderFns } from "./PreloaderMini.vue?vue&type=template&id=b1b81fb6&scoped=true&"
import script from "./PreloaderMini.vue?vue&type=script&lang=js&"
export * from "./PreloaderMini.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderMini.vue?vue&type=style&index=0&id=b1b81fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b81fb6",
  null
  
)

export default component.exports